<template>
  <Header>
    <Search @result="onSearch" @clear="fetchPins" @toggle-hidden="toggleHidden" />
  </Header>

  <main class="h-[calc(100dvh-3.75rem)] bg-[#A1E8EA] relative">
    <button class="btn btn-sm btn-outline btn-primary absolute z-10 top-4 right-0 sm:right-4 normal-case"
      @click="mapToggle = !mapToggle">
      <ListBulletIcon v-if="mapToggle" class="w-4 h-4 text-accent" />
      <MapIcon v-else class="w-4 h-4 text-accent" />
      <span class="hidden sm:block">
        {{ mapToggle ? $t('listView') : $t('mapView') }}
      </span>
    </button>
    <Map v-if="mapToggle" :focused-pin="focusedPin" @pin-focused="focusedPin = undefined" />
    <List v-else @select="(value) => onSelect(value)" />
  </main>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

import { usePinsStore } from '@/stores/pins'
import { ListBulletIcon, MapIcon } from '@heroicons/vue/24/solid'
import { storeToRefs } from 'pinia'

import type { Pin } from '@/interfaces'

import Header from '@/components/Header.vue'
import List from '@/components/List.vue'
import Map from '@/components/Map.vue'
import Search from '@/components/Search.vue'

const mapToggle = ref(true)
const focusedPin = ref<Pin>()

const pinsStore = usePinsStore()
const { pins } = storeToRefs(pinsStore)
const { setFilteredPins, fetchPins } = usePinsStore()

onMounted(() => {
  try {
    fetchPins()
  } catch (error) {
    if (error instanceof Error) {
      console.error(error.message)
    } else {
      console.error(error)
    }
  }
})

const onSearch = (searchResult: Pin[]) => {
  setFilteredPins(searchResult)
}

const onSelect = (pin: Pin) => {
  mapToggle.value = true
  focusedPin.value = pin
}

const toggleHidden = (value: boolean) => {
  if (value) {
    setFilteredPins(pins.value.filter((pin) => !pin.approved))
  } else {
    setFilteredPins(pins.value)
  }
}
</script>
